import { render, staticRenderFns } from "./FollowBtn.vue?vue&type=template&id=333d55b8&scoped=true&"
import script from "./FollowBtn.vue?vue&type=script&lang=js&"
export * from "./FollowBtn.vue?vue&type=script&lang=js&"
import style0 from "./FollowBtn.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FollowBtn.vue?vue&type=style&index=1&id=333d55b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d55b8",
  null
  
)

export default component.exports